class SubscriptionProductsCarousel extends HTMLElement {
  connectedCallback() {
    const carousel = this.querySelector("swiper-container");
    const dots = this.querySelector(".sub-products__dots");
    if (!carousel) return;

    Object.assign(carousel, {
      slidesPerView: 1.3,
      spaceBetween: 12,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      mousewheel: { enabled: true, forceToAxis: true },
      pagination: { el: dots, clickable: true },
      breakpoints: {
        560: { slidesPerView: 2.2 },
        860: { slidesPerView: 3.2 },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        }
      }
    });

    carousel.initialize();
  }
}

if (!customElements.get("subscription-products-carousel")) {
  customElements.define("subscription-products-carousel", SubscriptionProductsCarousel);
}
